// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eS","menuControls_styleDefault":"c-a_eT","menuControls_styleRed":"c-a_eU"};